import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  scrollable: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflowX: 'scroll',
    marginBottom: '10px'
  },
  chip: {
    margin: '0 5px'
  },
  buttonsMargin: {
    margin: '5px'
  },
  inputsMargin: {
    margin: '6px 0'
  }
});